import { render, staticRenderFns } from "./groupBrokerage.vue?vue&type=template&id=c62d66b8&"
import script from "./groupBrokerage.vue?vue&type=script&lang=js&"
export * from "./groupBrokerage.vue?vue&type=script&lang=js&"
import style0 from "./groupBrokerage.vue?vue&type=style&index=0&id=c62d66b8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.2/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports